import { normalizeToUTC } from "@revbox/helpers-fe";
import axiosInstance from "../../axios/instance";
import { getToken } from "../../helpers/get-token";
async function getPeriodCampaignMap(currentPeriod, previousPeriod, campaignId) {
    try {
        const token = getToken();
        axiosInstance.defaults.headers.common['authorization'] = token;
        const response = await axiosInstance.post(process.env.REACT_APP_HUB_URL + '/api/analytics/campaign/period/map', {
            current_period: [normalizeToUTC(currentPeriod[0]).getTime(), normalizeToUTC(currentPeriod[1]).getTime()],
            previous_period: [normalizeToUTC(previousPeriod[0]).getTime(), normalizeToUTC(previousPeriod[1]).getTime()],
            campaign_id: campaignId
        })
        return response?.data?.data;
    } catch (error) {
        console.log(error);
    }
}

export default getPeriodCampaignMap;
